// src/pages/DepositWithdraw.jsx
import React, { useState, useEffect, useRef } from 'react';
import api from '../api';
import { Link, useNavigate } from 'react-router-dom';
import './DepositWithdraw.css';
import { ArrowUpCircle, ArrowDownCircle, Upload, CreditCard, AlertCircle, CheckCircle, Copy, Check, X, RefreshCw, Wallet, Banknote, Coins, ReceiptText, ChevronLeft, ArrowRight, ArrowUpRight, Clock, MessageCircle } from '../components/icons';

export default function DepositWithdraw() {
  const [balance, setBalance] = useState({ balance_rial: null, balance_gold: null });
  const [bankAccounts, setBankAccounts] = useState([]);
  const [amount, setAmount] = useState('');
  const [bankAccountId, setBankAccountId] = useState('');
  const [receipt, setReceipt] = useState(null);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [activeTab, setActiveTab] = useState('deposit');
  const [isUploading, setIsUploading] = useState(false);
  const [isWithdrawing, setIsWithdrawing] = useState(false);
  const [cancellingId, setCancellingId] = useState(null);
  const [receiptPreview, setReceiptPreview] = useState('');
  const submissionBusy = useRef(false);
  const cancellationBusy = useRef(false);
  useEffect(() => {
    if (!receipt) { setReceiptPreview(''); return undefined; }
    const url = URL.createObjectURL(receipt); setReceiptPreview(url);
    return () => URL.revokeObjectURL(url);
  }, [receipt]);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [pendingRequests, setPendingRequests] = useState([]);
  const [cardCopied, setCardCopied] = useState(false);
  const [shebaCopied, setShebaCopied] = useState(false);
  const navigate = useNavigate();
  const token = localStorage.getItem('authToken');

  // --- نقشه لوگوهای بانک ---
  const bankLogos = {
    'انصار': '/bank-logos/Ansar.svg',
    'آینده': '/bank-logos/Ayandeh.svg',
    'بانک مرکزی': '/bank-logos/Bank_Markazi.svg',
    'کاسپین': '/bank-logos/Caspian.svg',
    'دی': '/bank-logos/Dey.svg',
    'اقتصاد نوین': '/bank-logos/Eghtesad_Novin.svg',
    'فیوچربانک': '/bank-logos/Futurebank.svg',
    'گردشگری': '/bank-logos/Gardeshgari.svg',
    'قوامین': '/bank-logos/Ghavamin.svg',
    'حکمت': '/bank-logos/Hekmat.svg',
    'ایران اروپا': '/bank-logos/Iran_Europe.svg',
    'ایران ونزوئلا': '/bank-logos/Iran_Venezuela.svg',
    'ایران زمین': '/bank-logos/Iran_Zamin.svg',
    'کارآفرین': '/bank-logos/Karafarin.svg',
    'کشاورزی': '/bank-logos/Keshavarzi.svg',
    'خاورمیانه': '/bank-logos/Khavar_Mianeh.svg',
    'کوشار': '/bank-logos/Kosar.svg',
    'مسکن': '/bank-logos/Maskan.svg',
    'مهر اقتصاد': '/bank-logos/Mehr_Eghtesad.svg',
    'مهر ایران': '/bank-logos/Mehr_Iran.svg',
    'ملل': '/bank-logos/Melall.svg',
    'ملت': '/bank-logos/Mellat.svg',
    'ملی': '/bank-logos/Melli.svg',
    'نور': '/bank-logos/Noor.svg',
    'پارسیان': '/bank-logos/Parsian.svg',
    'پاسارگاد': '/bank-logos/Pasargad.svg',
    'پست بانک': '/bank-logos/Postbank.svg',
    'رفاه': '/bank-logos/Refah.svg',
    'رسالت': '/bank-logos/Resalat.svg',
    'صادرات': '/bank-logos/Saderat.svg',
    'سامان': '/bank-logos/Saman.svg',
    'صنعت و معدن': '/bank-logos/Sanat_Madan.svg',
    'سرمایه': '/bank-logos/Sarmayeh.svg',
    'سپه': '/bank-logos/Sepah.svg',
    'شهر': '/bank-logos/Shahr.svg',
    'سینا': '/bank-logos/Sina.svg',
    'استاندارد چارترد': '/bank-logos/Standard_Chartered.svg',
    'تعاون اسلامی': '/bank-logos/Taavon_Eslami.svg',
    'تجارت': '/bank-logos/Tejarat.svg',
    'توسعه': '/bank-logos/Tosee.svg',
    'توسعه صادرات': '/bank-logos/Tosee_Saderat.svg',
    'توسعه تعاون': '/bank-logos/Tosee_Taavon.svg',
    default: '/bank-logos/default.svg',
  };

  // --- توابع کمکی ---
  const persianToEnglishDigits = (str) => {
    const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
    const englishDigits = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
    let result = str || '';
    for (let i = 0; i < persianDigits.length; i++) {
      result = result.replace(new RegExp(persianDigits[i], 'g'), englishDigits[i]);
    }
    return result;
  };

  const formatNumber = (value) => {
    if (!value) return '';
    const rawValue = persianToEnglishDigits(value).replace(/[^\d]/g, '');
    return rawValue ? parseInt(rawValue).toLocaleString('fa-IR') : '';
  };

  const toTomanText = rial => Math.floor(Number(rial) / 10).toLocaleString('fa-IR') + ' \u062a\u0648\u0645\u0627\u0646';

  const handleAmountChange = (e) => {
    const inputValue = e.target.value;
    const rawValue = persianToEnglishDigits(inputValue).replace(/[\u0660-\u0669]/g, digit => String(digit.charCodeAt(0) - 0x660)).replace(/[^\d]/g, '');
    setAmount(rawValue);
  };

  // --- توابع API ---
  const refreshAccessToken = async () => {
    try {
      const refreshToken = localStorage.getItem('refreshToken');
      if (!refreshToken) throw new Error('No refresh token');
      const res = await api.post('/api/auth/refresh-token', { refreshToken });
      localStorage.setItem('authToken', res.data.accessToken);
      return res.data.accessToken;
    } catch (err) {
      if (err.response?.status !== 401 && localStorage.getItem('refreshToken')) throw err;
      localStorage.removeItem('authToken');
      localStorage.removeItem('refreshToken');
      navigate('/login_page');
      return null;
    }
  };

  const fetchUserAndBalance = async () => {
    try {
      const newToken = token || (await refreshAccessToken());
      if (!newToken) throw new Error('No token');
      const res = await api.get('/api/users/me', {
        headers: { Authorization: `Bearer ${newToken}` },
      });
      setBalance(res.data.balance || { balance_rial: null, balance_gold: null });
    } catch (err) {
      setError(err.response?.data?.message || 'خطا در دریافت اطلاعات کاربر');
    }
  };

  const fetchBankAccounts = async () => {
    try {
      const newToken = token || (await refreshAccessToken());
      if (!newToken) throw new Error('No token');
      const res = await api.get('/api/bank-accounts', {
        headers: { Authorization: `Bearer ${newToken}` },
      });
      setBankAccounts(res.data);
    } catch (err) {
      setError(err.response?.data?.message || 'خطا در دریافت حساب‌های بانکی');
    }
  };

  const fetchPendingRequests = async () => {
    try {
      const newToken = token || (await refreshAccessToken());
      if (!newToken) throw new Error('No token');
      const res = await api.get('/api/wallet/requests/pending', {
        headers: { Authorization: `Bearer ${newToken}` },
      });
      setPendingRequests(res.data);
    } catch (err) {
      setError(err.response?.data?.message || 'خطا در دریافت درخواست‌های pending');
    }
  };

  useEffect(() => {
    if (!token) {
      navigate('/login_page');
      return;
    }
    fetchUserAndBalance();
    fetchBankAccounts();
    fetchPendingRequests();
  }, [token, navigate]);

  const handleDeposit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    if (submissionBusy.current) return;
    submissionBusy.current = true;
    setIsUploading(true);
    setUploadProgress(0);

    try {
      if (!amount || !Number.isFinite(Number(amount)) || Number(amount) <= 0) {
        setError('لطفاً یک مقدار عددی معتبر وارد کنید');
          setIsUploading(false);
        return;
      }
      if (!receipt) {
        setError('لطفاً فیش واریزی را انتخاب کنید');
          setIsUploading(false);
        return;
      }

      const newToken = token || (await refreshAccessToken());
      if (!newToken) throw new Error('No token');
      const formData = new FormData();
      formData.append('amount', amount);
      formData.append('receipt', receipt);

      await api.post('/api/wallet/deposit', formData, {
        headers: {
          Authorization: `Bearer ${newToken}`,
          'Content-Type': 'multipart/form-data',
        },
        onUploadProgress: (progressEvent) => {
          const percentCompleted = progressEvent.total ? Math.min(100, Math.round((progressEvent.loaded * 100) / progressEvent.total)) : 0;
          setUploadProgress(percentCompleted);
        },
      });

      setSuccess('درخواست شارژ ثبت شد');
      setAmount('');
      setReceipt(null);
      fetchPendingRequests();
      fetchUserAndBalance();
    } catch (err) {
      setError(err.response?.data?.message || 'خطا در ثبت شارژ');
    } finally {
      submissionBusy.current = false;
      setIsUploading(false);
    }
  };

  const handleWithdraw = async (e) => {
    e.preventDefault();
    if (submissionBusy.current) return;
    submissionBusy.current = true;
    setIsWithdrawing(true); setError(''); setSuccess('');
    try {
      if (!amount || !Number.isFinite(Number(amount)) || Number(amount) <= 0) {
        setError('لطفاً یک مقدار عددی معتبر وارد کنید');
          return;
      }
      if (parseFloat(amount) > balance.balance_rial) {
        setError('موجودی کافی نیست');
          return;
      }

      const newToken = token || (await refreshAccessToken());
      if (!newToken) throw new Error('No token');
      await api.post('/api/wallet/withdraw', { amount, bank_account_id: bankAccountId }, {
        headers: { Authorization: `Bearer ${newToken}` },
      });
      setSuccess('درخواست برداشت ثبت شد');
      setAmount('');
      setBankAccountId('');
      fetchUserAndBalance();
      fetchPendingRequests();
    } catch (err) {
      setError(err.response?.data?.message || 'خطا در ثبت برداشت');
    } finally {
      submissionBusy.current = false;
      setIsWithdrawing(false);
    }
  };

  const handleCancelRequest = async (requestId) => {
    if (cancellationBusy.current) return;
    cancellationBusy.current = true; setCancellingId(requestId);
    try {
      const newToken = token || (await refreshAccessToken());
      if (!newToken) throw new Error('No token');
      await api.post(`/api/wallet/requests/cancel/${requestId}`, {}, {
        headers: { Authorization: `Bearer ${newToken}` },
      });
      setSuccess('درخواست برداشت با موفقیت لغو شد');
      fetchPendingRequests();
    } catch (err) {
      setError(err.response?.data?.message || 'خطا در لغو درخواست');
    } finally {
      cancellationBusy.current = false;
      setCancellingId(null);
    }
  };

  const formatCardNumber = (num) => num.replace(/(\d{4})(?=\d)/g, '$1 - ');
  const formatIban = (iban) => {
    const cleaned = iban.replace(/\s/g, '');
    return cleaned.replace(/(IR\d{2})(\d{4})(\d{4})(\d{4})(\d{4})(\d{4})(\d{2})/, '$1 - $2 - $3 - $4 - $5 - $6 - $7');
  };

  const getBankLogo = (name) => bankLogos[name?.trim()] || bankLogos.default;

  // --- تابع کپی با انیمیشن ---
  const copyToClipboard = async (text, type) => {
    try {
      let copied = false;
      if (navigator.clipboard && window.isSecureContext) {
        try { await navigator.clipboard.writeText(text); copied = true; } catch {}
      }
      if (!copied) {
        const field = document.createElement('textarea'); field.value = text;
        field.style.position = 'fixed'; field.style.opacity = '0';
        const focused = document.activeElement; document.body.appendChild(field);
        field.focus(); field.select(); field.setSelectionRange(0, text.length);
        try { copied = document.execCommand('copy'); }
        finally { field.remove(); focused?.focus(); }
      }
      if (!copied) throw new Error('Copy failed');
      if (type === 'card') {
        setCardCopied(true);
        setSuccess('شماره کارت کپی شد!');
      } else if (type === 'sheba') {
        setShebaCopied(true);
        setSuccess('شماره شبا کپی شد!');
      }
      setTimeout(() => {
        setSuccess('');
        if (type === 'card') setCardCopied(false);
        if (type === 'sheba') setShebaCopied(false);
      }, 1500);
    } catch (err) {
      setError('خطا در کپی کردن');
      setTimeout(() => setError(''), 2000);
    }
  };

  const rialText = value => value != null && Number.isFinite(Number(value)) ? Number(value).toLocaleString('fa-IR') : '—';
  const goldText = value => value != null && Number.isFinite(Number(value)) ? Number(value).toLocaleString('fa-IR', { minimumFractionDigits: 3, maximumFractionDigits: 3 }) : '—';
  const changeTab = tab => { if (!isUploading && !isWithdrawing) { setActiveTab(tab); setError(''); setSuccess(''); } };
  const selectReceipt = event => {
    const file = event.target.files?.[0];
    if (!file) return;
    if (!['image/jpeg', 'image/png'].includes(file.type) || file.size > 10 * 1024 * 1024) {
      setError('فیش باید تصویر JPG یا PNG و حداکثر ۱۰ مگابایت باشد.'); event.target.value = ''; return;
    }
    setReceipt(file); setError('');
  };

  return <div className="wallet-redesign" dir="rtl">
    <Link className="wallet-back" to="/"><ArrowRight size={16} /> بازگشت به خانه</Link>
    <section className="wallet-hero"><div><span className="wallet-eyebrow">ESF GOLD / WALLET</span><h1>مدیریت پول،<br /><span>با خیال روشن‌تر.</span></h1><p>واریز و برداشت حساب خود را از همین‌جا مدیریت کنید.</p></div><div className="wallet-hero__symbol" aria-hidden="true"><Wallet size={48} /></div><Link className="wallet-hero__history" to="/wallet-requests_page">پیگیری درخواست‌ها <ArrowUpRight size={17} /></Link></section>
    <section className="wallet-overview" aria-label="موجودی حساب"><article><span className="wallet-overview__icon"><Banknote size={23} /></span><span>موجودی ریالی حساب</span><strong>{rialText(balance.balance_rial)} <small>ریال</small></strong><p>{balance.balance_rial != null ? `${rialText(Math.floor(Number(balance.balance_rial) / 10))} تومان` : 'در حال دریافت اطلاعات حساب'}</p></article><article><span className="wallet-overview__icon wallet-overview__icon--gold"><Coins size={23} /></span><span>موجودی طلای حساب</span><strong>{goldText(balance.balance_gold)} <small>گرم</small></strong><p>موجودی ثبت‌شده در حساب شما</p></article><Link className="wallet-overview__link" to="/transactions_page"><ReceiptText size={24} /><span><strong>گردش حساب</strong><small>جزئیات و سابقه تراکنش‌ها</small></span><ChevronLeft size={18} /></Link></section>
    <div className="wallet-grid">
      <section className="wallet-workspace" aria-labelledby="wallet-form-title">
        <div className="wallet-tabs" role="tablist" aria-label="نوع عملیات کیف پول"><button id="wallet-deposit-tab" role="tab" type="button" aria-selected={activeTab === 'deposit'} aria-controls="wallet-panel" disabled={isUploading || isWithdrawing} onClick={() => changeTab('deposit')} className={activeTab === 'deposit' ? 'is-active' : ''}><ArrowUpCircle size={20} /> واریز به حساب</button><button id="wallet-withdraw-tab" role="tab" type="button" aria-selected={activeTab === 'withdraw'} aria-controls="wallet-panel" disabled={isUploading || isWithdrawing} onClick={() => changeTab('withdraw')} className={activeTab === 'withdraw' ? 'is-active' : ''}><ArrowDownCircle size={20} /> برداشت از حساب</button></div>
        <div id="wallet-panel" role="tabpanel" aria-labelledby={activeTab === 'deposit' ? 'wallet-deposit-tab' : 'wallet-withdraw-tab'} className="wallet-panel">
          <div className="wallet-form-heading"><span className="wallet-step">{activeTab === 'deposit' ? <Upload size={21} /> : <CreditCard size={21} />}</span><div><h2 id="wallet-form-title">{activeTab === 'deposit' ? 'ثبت فیش واریزی' : 'ثبت درخواست برداشت'}</h2><p>{activeTab === 'deposit' ? 'پس از واریز به حساب مقصد، مبلغ و تصویر فیش را ثبت کنید.' : 'مبلغ و حساب بانکی مقصد را انتخاب کنید.'}</p></div></div>
          {error && <div className="wallet-message wallet-message--error" role="alert"><AlertCircle size={19} /><span>{error}</span><button type="button" aria-label="بستن پیام خطا" onClick={() => setError('')}><X size={16} /></button></div>}
          {success && <div className="wallet-message wallet-message--success" role="status"><CheckCircle size={19} /><span>{success}</span><button type="button" aria-label="بستن پیام موفقیت" onClick={() => setSuccess('')}><X size={16} /></button></div>}
          <form onSubmit={activeTab === 'deposit' ? handleDeposit : handleWithdraw} aria-busy={isUploading || isWithdrawing}>
            <label className="wallet-field-label" htmlFor="wallet-amount">{activeTab === 'deposit' ? 'مبلغ واریزی' : 'مبلغ برداشت'}<span>ریال</span></label><div className="wallet-amount-control"><input id="wallet-amount" type="text" inputMode="numeric" autoComplete="off" dir="ltr" placeholder="۰" value={formatNumber(amount)} onChange={handleAmountChange} disabled={isUploading || isWithdrawing} aria-describedby="wallet-amount-help" /><span>ریال</span></div><p id="wallet-amount-help" className="wallet-amount-help">{amount ? `معادل ${toTomanText(amount)}` : 'مبلغ را به ریال وارد کنید؛ معادل تومان اینجا نمایش داده می‌شود.'}</p>
            {activeTab === 'deposit' ? <div className="wallet-receipt"><span className="wallet-field-label">تصویر فیش واریزی</span>{receipt ? <div className="wallet-receipt__selected">{receiptPreview && <img src={receiptPreview} alt="پیش‌نمایش فیش انتخاب‌شده" />}<div><strong>{receipt.name}</strong><small>{(receipt.size / 1024 / 1024).toLocaleString('fa-IR', { maximumFractionDigits: 2 })} مگابایت</small><button type="button" disabled={isUploading} onClick={() => setReceipt(null)}><X size={14} /> حذف و انتخاب دوباره</button></div></div> : <label className="wallet-upload" htmlFor="wallet-receipt-input"><span><Upload size={25} /></span><strong>انتخاب تصویر فیش</strong><small>JPG یا PNG · حداکثر ۱۰ مگابایت</small><input id="wallet-receipt-input" type="file" accept="image/jpeg,image/png" onChange={selectReceipt} aria-label="انتخاب تصویر فیش واریزی" disabled={isUploading} /></label>}</div> : <fieldset className="wallet-accounts"><legend className="wallet-field-label">حساب مقصد برداشت<Link to="/bank-accounts_page">مدیریت حساب‌ها <ArrowUpRight size={14} /></Link></legend>{bankAccounts.length === 0 ? <div className="wallet-empty"><CreditCard size={28} /><strong>حساب بانکی ثبت‌شده‌ای نمایش داده نمی‌شود</strong><p>برای دریافت وجه، حساب بانکی خود را اضافه کنید.</p><Link to="/bank-accounts_page">افزودن حساب بانکی <ArrowUpRight size={16} /></Link></div> : bankAccounts.map(account => <label key={account.id} className={`wallet-account${String(bankAccountId) === String(account.id) ? ' is-selected' : ''}`}><input type="radio" name="bankAccount" value={account.id} checked={String(bankAccountId) === String(account.id)} onChange={() => setBankAccountId(account.id)} disabled={isWithdrawing} /><img src={getBankLogo(account.bank_name)} alt="" onError={event => { if (!event.currentTarget.src.endsWith(bankLogos.default)) event.currentTarget.src = bankLogos.default; }} /><span><strong>{account.bank_name}</strong><small>{account.account_holder_name}</small><b dir="ltr">{formatCardNumber(account.card_number || '')}</b><small dir="ltr">{formatIban(account.iban || '')}</small></span>{String(bankAccountId) === String(account.id) && <CheckCircle size={20} className="wallet-account__check" />}</label>)}</fieldset>}
            {isUploading && <div className="wallet-progress" role="status"><div><span>در حال ارسال فیش…</span><span>{uploadProgress.toLocaleString('fa-IR')}٪</span></div><progress max="100" value={uploadProgress} aria-label="پیشرفت ارسال فیش" /></div>}
            <button type="submit" className="wallet-submit" disabled={isUploading || isWithdrawing || !amount || Number(amount) <= 0 || (activeTab === 'deposit' ? !receipt : !bankAccountId || balance.balance_rial == null)}>{isUploading || isWithdrawing ? <RefreshCw size={20} className="wallet-spinning" /> : activeTab === 'deposit' ? <ArrowUpCircle size={20} /> : <ArrowDownCircle size={20} />}{isUploading ? 'در حال ثبت واریز…' : isWithdrawing ? 'در حال ثبت برداشت…' : activeTab === 'deposit' ? 'ثبت درخواست واریز' : 'ثبت درخواست برداشت'}</button><p className="wallet-submit-note">{activeTab === 'deposit' ? 'ثبت فیش به معنی شارژ فوری حساب نیست؛ درخواست پس از بررسی تأیید می‌شود.' : 'این عملیات یک درخواست برداشت ثبت می‌کند؛ وضعیت آن را در بخش پیگیری ببینید.'}</p>
          </form>
        </div>
      </section>
      <aside className="wallet-sidebar">
        {activeTab === 'deposit' ? <section className="wallet-destination"><div className="wallet-side-heading"><span><CreditCard size={21} /></span><div><small>اطلاعات واریز</small><h2>حساب مقصد واریز</h2></div></div><div className="wallet-bank-card"><span>شماره کارت</span><strong dir="ltr">{formatCardNumber('6219861405418871')}</strong><div><small>به نام مهدی خرمی</small><button type="button" onClick={() => copyToClipboard('6219861405418871', 'card')} aria-label="کپی شماره کارت">{cardCopied ? <Check size={17} /> : <Copy size={17} />}{cardCopied ? 'کپی شد' : 'کپی'}</button></div></div><div className="wallet-iban"><span>شماره شبا</span><strong dir="ltr">{formatIban('IR910560611828006882072801')}</strong><button type="button" onClick={() => copyToClipboard('910560611828006882072801', 'sheba')}>{shebaCopied ? <Check size={16} /> : <Copy size={16} />}{shebaCopied ? 'شماره شبا کپی شد' : 'کپی شماره شبا'}</button></div><div className="wallet-warning"><AlertCircle size={18} /><p>واریز فقط از حساب <strong>به نام خودتان</strong> پذیرفته می‌شود. در صورت مغایرت، مبلغ پس از <strong>۷۲ ساعت</strong> عودت می‌شود.</p></div></section> : <section className="wallet-withdraw-guide"><span className="wallet-side-icon"><ArrowDownCircle size={26} /></span><h2>برداشت، قدم به قدم</h2><ol><li>مبلغ برداشت را به ریال وارد کنید.</li><li>حساب بانکی خود را انتخاب کنید.</li><li>درخواست را ثبت و وضعیت آن را پیگیری کنید.</li></ol><Link to="/wallet-requests_page">پیگیری درخواست‌ها <ArrowUpRight size={17} /></Link></section>}
        <section className="wallet-pending"><div className="wallet-side-heading"><span><Clock size={19} /></span><div><small>پیگیری حساب</small><h2>برداشت‌های در انتظار</h2></div><b>{pendingRequests.length.toLocaleString('fa-IR')}</b></div>{pendingRequests.length ? pendingRequests.map(request => <article key={request.id}><div><strong>{rialText(request.amount)} <small>ریال</small></strong><time>{new Date(request.created_at).toLocaleString('fa-IR', { timeZone: 'Asia/Tehran', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' })}</time></div><button type="button" disabled={cancellingId != null || isUploading || isWithdrawing} onClick={() => handleCancelRequest(request.id)}>{cancellingId === request.id ? 'در حال لغو…' : 'لغو درخواست'}</button></article>) : <p className="wallet-pending__empty">درخواست برداشت در انتظاری نمایش داده نمی‌شود.</p>}<Link to="/wallet-requests_page">مشاهده همه درخواست‌ها <ChevronLeft size={15} /></Link></section>
        <Link className="wallet-support" to="/chat_page"><MessageCircle size={22} /><span><strong>برای واریز یا برداشت راهنمایی می‌خواهید؟</strong><small>گفت‌وگو با پشتیبانی</small></span><ChevronLeft size={16} /></Link>
      </aside>
    </div>
  </div>;
}
